<svg width="800px" height="800px" fill="none" stroke="black" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
 <path d="m8 6 13 7.8e-4m-13 5.9992 13 8e-4m-13 5.9992 13 7e-4m-18-11.501h1v-1h-1v1zm0 6h1v-1h-1v1zm0 6h1v-1h-1v1z" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
</svg>
